import { getBcOrderId, getBcShopName, getBcCustomerId } from "../helpers";
import { getCheckIdFromLocalStorage } from "./precheckout";
import axios from "../utilities/axios";
import console from "../log";
// The post-checkout associate calls (WC + BC) are flipped to the Fastify host —
// handler ported & verified live on the Lambda (#2525). Other VITE_REAL_ID_HOST
// callers stay on Vercel.
const REAL_ID_FASTIFY_HOST = process.env.VITE_REAL_ID_FASTIFY_HOST || "https://real-id-api.getverdict.com";
export async function associateWcIdCheckWithOrder() {
    const checkId = getCheckIdFromLocalStorage();
    const orderId = window.realIdOrder?.id;
    const customerId = window.realIdOrder?.customer?.id;
    console.debug(`Real ID :: post-checkout order ID association :: associating ${checkId} with ${orderId}`);
    if (orderId && checkId) {
        await axios.post(`${REAL_ID_FASTIFY_HOST}/api/checks/${checkId}/associate`, {
            wcOrderId: orderId,
            wcCustomerId: customerId,
        });
    }
}
export async function associateBcIdCheckWithOrder() {
    const checkId = getCheckIdFromLocalStorage();
    const orderId = getBcOrderId();
    const customerId = getBcCustomerId();
    const shopName = getBcShopName();
    console.debug(`Real ID :: BigCommerce post-checkout order ID association :: associating ${checkId} with ${orderId}`);
    if (orderId && checkId && shopName) {
        // Using the same associate endpoint but with BC-specific parameters
        await axios.post(`${REAL_ID_FASTIFY_HOST}/api/checks/${checkId}/associate`, {
            bcOrderId: orderId,
            bcCustomerId: customerId,
            bcShopName: shopName,
            platform: "bc"
        });
    }
}
